/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import LineChart from 'loracoms/LineChart';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';


const defaultProps = {
  resize: 0,
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pktStats: React.PropTypes.object.isRequired,
  resize: React.PropTypes.number,
};

function formatSlot(slot) {
  const s = String(slot);
  if (s.length >= 10) {
    return `${s.slice(6, 8)}/${s.slice(4, 6)} ${s.slice(8, 10)}:00`;
  } else if (s.length >= 8) {
    return `${s.slice(6, 8)}/${s.slice(4, 6)}`;
  }
  return s.slice(4, 6);
}

class GatewayPktTrend extends React.Component {

  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.statschart');
    this.state = {
      series: {
        rxpkt: {
          name: this.intlMsg.msg('series.pkts'),
          data: [],
          yAxisIndex: 0,
        },
        rxpktau: {
          name: this.intlMsg.msg('series.pktsau'),
          data: [],
          yAxisIndex: 0,
        },
        rxpktun: {
          name: this.intlMsg.msg('series.pktsun'),
          data: [],
          yAxisIndex: 0,
        },
        ltncs: {
          name: this.intlMsg.msg('series.latency'),
          data: [],
          yAxisIndex: 1,
        },
        categories: [],
      },
      resize: props.resize,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { pktStats, resize } = nextProps;
    if (pktStats !== this.props.pktStats) {
      if (pktStats.status === 'success') {
        const { data } = pktStats;
        const rxpkt = [];
        const rxpktau = [];
        const rxpktun = [];
        const ltncs = [];
        const slots = [];
        data.list.forEach((item) => {
          slots.push(formatSlot(item.slot));
          rxpkt.push(item.rxpkt);
          rxpktun.push(item.rxpktun);
          rxpktau.push(item.rxpkt - item.rxpktun);
          ltncs.push(item.latency);
        });

        const { series } = this.state;
        series.rxpkt.data = rxpkt;
        series.rxpktau.data = rxpktau;
        series.rxpktun.data = rxpktun;
        series.ltncs.data = ltncs;
        series.categories = slots;
        this.setState({ series });
      }
    }
    if (resize !== this.props.resize) {
      this.setState({ resize });
    }
  }

  render() {
    const { series, resize } = this.state;

    return (
      <div className={styles.chart}>
        <LineChart
          yAxis={[{
            name: this.intlMsg.msg('axis.pkts'),
            splitNumber: 5,
          }, {
            name: this.intlMsg.msg('axis.latency'),
            splitLine: { show: false },
          }]}
          legend={{
            data: [
              this.intlMsg.msg('series.pkts'),
              this.intlMsg.msg('series.pktsau'),
              this.intlMsg.msg('series.pktsun'),
              this.intlMsg.msg('series.latency'),
            ],
          }}
          series={[
            series.rxpkt,
            series.rxpktau,
            series.rxpktun,
            series.ltncs,
          ]}
          categories={series.categories}
          dataZoom={[{
            type: 'slider',
            fillerColor: 'rgba(228, 241, 254, 0.4)',
            dataBackground: {
              lineStyle: { width: 0 },
              areaStyle: { color: 'rgba(107, 185, 240, 0.8)' },
            },
          }]}
          grid={{
            left: 60,
            top: 30,
            right: 30,
            bottom: 60,
          }}
          resize={resize}
        />
      </div>
    );
  }
}


GatewayPktTrend.defaultProps = defaultProps;
GatewayPktTrend.propTypes = propTypes;

const mapStateToProps = state => ({
  pktStats: state.gateway.getGatewayPktStats,
});

const mapDispatchToProps = {

};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GatewayPktTrend));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayPktTrend/index.jsx